// extracted by mini-css-extract-plugin
export var orderSummary = "_nl-0";
export var showMoreLessButton = "_nl-1";